import { decodeHTML } from 'entities';
import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { getMACAA010Action, postMACAA010 } from '../../../services/Api';
import Pagination from '../../../shared/components/Pagination';
import SideMenu from '../../../shared/components/SideMenu';
import { MENU_APPROVE } from '../../../shared/constants/app';
import { formatDate, formatNumberWithCommas, decodeHTMLEntities } from '../../../utils';

const MACAA010 = () => {
    const [data, setData] = useState([]);
    const [pages, setPages] = useState({});
    const [searchParams] = useSearchParams();
    const page = Number(searchParams.get('page')) || 1;

    const getListData = () => {
        postMACAA010({ page })
            .then(({ data }) => {
                setData(data.data);
                setPages(data.info);
            })
            .catch((error) => console.log(error));
    };
    useEffect(() => {
        getListData();
        // eslint-disable-next-line
    }, [page]);

    const approve = (seq) => {
        if (window.confirm('승인하시겠습니까?')) {
            getMACAA010Action('approve', seq)
                .then(() => {
                    window.alert('승인되었습니다.');
                    getListData();
                })
                .catch((error) => console.log(error));
        }
    };

    const refuse = (seq) => {
        if (window.confirm('거절하시겠습니까?')) {
            getMACAA010Action('reject', seq)
                .then(() => {
                    window.alert('거절되었습니다.');
                    getListData();
                })
                .catch((error) => console.log(error));
        }
    };

    return (
        <div className="container">
            <div className="wrap">
                <SideMenu menu={MENU_APPROVE} />
                <div className="content-right">
                    <h1 className="title">등록승인</h1>
                    <div className="results gray">
                        <div className="count">
                            승인 대기 광고: <span className="red">{formatNumberWithCommas(pages?.totalRow || 0)}</span>
                            건
                        </div>
                        <table className="table table-gray">
                            <thead>
                                <tr>
                                    <th style={{ width: '100px' }}>승인여부</th>
                                    <th>등록일</th>
                                    <th>아이디</th>
                                    <th style={{ width: '100px' }}>치과명</th>
                                    <th>채용공고 내용</th>
                                    <th>모집기간</th>
                                    <th style={{ width: '80px' }}>결제상태</th>
                                    <th>결제일</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data && data.length > 0 ? (
                                    data.map((item, index) => (
                                        <tr key={index}>
                                            <td>
                                                <div className="mb-2">
                                                    <Link
                                                        className="text-decoration-underline"
                                                        onClick={() => approve(item.seq)}
                                                    >
                                                        승인
                                                    </Link>
                                                </div>
                                                <div>
                                                    <Link
                                                        className="text-decoration-underline"
                                                        onClick={() => refuse(item.seq)}
                                                    >
                                                        거절
                                                    </Link>
                                                </div>
                                            </td>
                                            <td>{formatDate(item?.addDate)}</td>
                                            <td>{item?.memberID}</td>
                                            <td>{item?.companyName}</td>
                                            <td style={{ textAlign: 'start' }}>
                                                <div
                                                    className="contents"
                                                    dangerouslySetInnerHTML={{ __html: decodeHTMLEntities(item?.ftsContents) }}
                                                ></div>
                                            </td>
                                            <td>
                                                {formatDate(item?.recruitFrom)} ~ {formatDate(item?.recruitEnd)}
                                            </td>
                                            <td>{item?.resultCode === '00' ? '완료' : '입금대기'}</td>
                                            <td>{formatDate(item?.applDate)}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={8}>데이타가 없습니다.</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                        <Pagination pages={pages} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MACAA010;
